const PROD_DOMAIN = 'moneymade.io'
const PREPROD_DOMAIN = 'moneymade-preprod.vercel.app'
const STAGE_DOMAIN = 'moneymade-stage.vercel.app'

const DEV_API_MODE = false
const REDUX_DEV_TOOLS = +process.env.NEXT_PUBLIC_REDUX_DEV_TOOLS

const SENTRY_DNS = process.env.NEXT_PUBLIC_SENTRY_DNS

// Hotjar data
const HOTJAR_ID = +process.env.NEXT_PUBLIC_HOTJAR_ID
const HOTJAR_SV = +process.env.NEXT_PUBLIC_HOTJAR_SV

// Domain
const PRODUCTION_DOMAIN = process.env.NEXT_PUBLIC_PRODUCTION_DOMAIN

export {
  PROD_DOMAIN,
  PREPROD_DOMAIN,
  STAGE_DOMAIN,
  DEV_API_MODE,
  REDUX_DEV_TOOLS,
  SENTRY_DNS,
  HOTJAR_ID,
  HOTJAR_SV,
  PRODUCTION_DOMAIN
}
